// frontend/src/types/admin.types.ts

export interface AdminUserSummary {
  id: string;
  full_name: string;
  role: 'student' | 'parent' | 'admin';
  age: number | null;
  xp: number;
  is_banned: boolean;
  created_at: string;
  current_streak_days: number;
  school_name?: string | null;
  city?: string | null;
}

export interface AdminUserStats {
  totalUsers: number;
  totalStudents: number;
  totalParents: number;
  bannedUsers: number;
  activeThisWeek: number;
  premiumUsers: number;
}

export interface AdminCourse {
  id: string;
  title: string;
  description: string | null;
  category: string;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  is_published: boolean;
  order_index: number;
  cover_image_url?: string | null;
  created_at: string;
  age_category?: string | null;
}

export interface AdminLesson {
  id: string;
  course_id: string;
  title: string;
  topic?: string | null;
  content: string | null;
  video_url: string | null;
  image_url?: string | null;
  order_index: number;
  xp_reward: number;
}

export interface AdminLessonTopic {
  id: string;
  lesson_id: string;
  title: string;
  description: string | null;
  order_index: number;
  content?: string | null;
}

export interface AdminProject {
  id: string;
  title: string;
  description: string | null;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  starter_code: string | null;
  course_id: string | null;
  category?: string;
  is_published?: boolean;
  is_premium?: boolean;
  xp_reward?: number;
  estimated_duration?: string;
  created_at?: string;
}

export interface AiUsageSummary {
  totalCostUsd: number;
  totalCalls: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  byFeature: { feature: string; calls: number; costUsd: number }[];
  byDay: { date: string; costUsd: number; calls: number }[];
  topTopics: { topic: string; count: number }[];
  costPerStudent: { studentId: string; studentName: string; costUsd: number; calls: number }[];
}

export interface AdminOverview {
  totalCourses: number;
  totalLessons: number;
  totalProjects: number;
  totalSubmissions: number;
  totalQuizAttempts: number;
}

export const FEATURE_LABEL: Record<string, string> = {
  mentor_chat: 'AI Mentor Sohbeti',
  code_eval: 'Kod Değerlendirme',
  code_eval_detailed: 'Detaylı Kod Değerlendirme',
  project_eval: 'Proje Değerlendirme',
  quiz_gen: 'Quiz Üretimi',
  career_path: 'Kariyer Yolu Üretimi',
  parent_insight: 'Veli Özeti',
  lesson_explanation: 'Ders Açıklaması',
};

export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  role: string | null;
  message: string;
  status: string;
  created_at: string;
}
